export const SIZES = {
  xs: "xs",
  sm: "sm",
  default: "default",
  md: "md",
  lg: "lg",
  xl: "xl",
};
